import { OTHER } from './ClarificationField'

/** The value actually sent for one question: "Other" means the free-text box. */
function resolved(value, other) {
  return value === OTHER ? String(other ?? '').trim() : String(value ?? '').trim()
}

export function answerPayload(questions, values, others) {
  const answers = {}
  for (const question of questions) {
    const value = resolved(values[question.id], others[question.id])
    if (value) answers[question.id] = value
  }
  return answers
}

/**
 * Submit stays disabled until every required question has a real value.
 *
 * "Other" selected with an empty box counts as unanswered — otherwise the form
 * would post `__other__` as the answer, which the server rejects as an unknown
 * option and the user sees a 422 for a box they were looking at.
 */
export function requiredAnswered(questions, values, others) {
  return questions
    .filter((question) => question.required !== false)
    .every((question) => resolved(values[question.id], others[question.id]).length > 0)
}
